import { render, staticRenderFns } from "./AdaptedGoalsAccordion.vue?vue&type=template&id=7fbd7e7a"
import script from "./AdaptedGoalsAccordion.vue?vue&type=script&lang=js"
export * from "./AdaptedGoalsAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports